import { css } from "styled-components";
import { FontMixin } from "../../../../../../../../../styles/common/mixins/helpers.styled.js";
const universalMusicSearcherButtonStyles = {
    SearcherWrapper: ()=>css``,
    SearcherWrapperButton: ()=>css`
		${FontMixin({
            size: 'medium',
            weight: 'medium',
            height: 'base'
        })}
	`,
    NumberTextWrapper: ()=>css``,
    SearcherItemButtonDesktop: ()=>css``
};
export default universalMusicSearcherButtonStyles;

//# sourceMappingURL=partnershipsUniversalMusic.js.map